import { Inject, Injectable } from '@angular/core'
import { NumberService } from './number.service'
import _ from 'lodash'

@Injectable({
    providedIn: 'root'
})
export class ConvertDateUnitService {

    constructor(@Inject(NumberService) private numberService: NumberService,
                ) {
    }

    cloneAndConvertBarterDateUnitsToMonths(barter): any {
        let newBarter = _.cloneDeep(barter)
        this.convertBarterDateUnitsToMonths(newBarter)
        return newBarter
    }

    convertBarterDateUnitsFromMonths(barter): void {
        if (barter) {
            barter.durationMonths = this.convertDateUnitFromMonths(barter.durationMonths, barter.durationMonthsUnit)
            barter.noticePeriodMonths = this.convertDateUnitFromMonths(barter.noticePeriodMonths, barter.noticePeriodMonthsUnit)
        }
    }

    convertContractDateUnitsFromMonths(contract): any {
        if (contract) {
            contract.durationMonths = this.convertDateUnitFromMonths(contract.durationMonths, contract.durationMonthsUnit)
            contract.noticePeriodMonths = this.convertDateUnitFromMonths(contract.noticePeriodMonths, contract.noticePeriodMonthsUnit)
            contract.firstNoticeAfterMonths = this.convertDateUnitFromMonths(contract.firstNoticeAfterMonths, contract.firstNoticeAfterMonthsUnit)
            contract.lastNoticeBeforeMonths = this.convertDateUnitFromMonths(contract.lastNoticeBeforeMonths, contract.lastNoticeBeforeMonthsUnit)
            contract.autoProlongationMonths = this.convertDateUnitFromMonths(contract.autoProlongationMonths, contract.autoProlongationMonthsUnit)
        }
        return contract
    }

    convertContractDateUnitsToMonths(contract): any {
        if (contract) {
            contract.durationMonths = this.convertDateUnitToMonths(contract.durationMonths, contract.durationMonthsUnit)
            contract.noticePeriodMonths = this.convertDateUnitToMonths(contract.noticePeriodMonths, contract.noticePeriodMonthsUnit)
            contract.firstNoticeAfterMonths = this.convertDateUnitToMonths(contract.firstNoticeAfterMonths, contract.firstNoticeAfterMonthsUnit)
            contract.lastNoticeBeforeMonths = this.convertDateUnitToMonths(contract.lastNoticeBeforeMonths, contract.lastNoticeBeforeMonthsUnit)
            contract.autoProlongationMonths = this.convertDateUnitToMonths(contract.autoProlongationMonths, contract.autoProlongationMonthsUnit)
        }
        return contract
    }

    /**************************************************************************************************************/

    private convertBarterDateUnitsToMonths(barter): void {
        if (barter) {
            barter.durationMonths = this.convertDateUnitToMonths(barter.durationMonths, barter.durationMonthsUnit)
            barter.noticePeriodMonths = this.convertDateUnitToMonths(barter.noticePeriodMonths, barter.noticePeriodMonthsUnit)
        }
    }

    private convertDateUnitFromMonths(dateValue, dateUnit): number {
        if (dateUnit == 'Y') {
            return this.numberService.parseFloatOrZero(dateValue) / 12
        } else {
            return this.numberService.parseFloatOrZero(dateValue)
        }
    }

    private convertDateUnitToMonths(dateValue, dateUnit): number {
        if (dateUnit == 'Y') {
            return this.numberService.parseFloatOrZero(dateValue) * 12
        } else {
            return this.numberService.parseFloatOrZero(dateValue)
        }
    }
}